import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers';
import PropTypes from 'prop-types';
import React from 'react';
import { getTimeDiffText } from '../../helpers';
import DatePickerActionDates from './DatePickerActionDates';
import DatePickerTooltip from '../tooltips/DatePickerTooltip';
import dayjs from '../../config/dayjs';

const FingoGridDatePicker = ({
  value,
  onChange,
  onChangeAll,
  debtorAveragePaymentDays,
  minDate,
  maxDate,
  disabled,
  closeDatePicker,
  shouldDisableWeekend,
}) => {
  const handleRenderDay = (day, _selectedDates, pickersDayProps) => (
    <DatePickerTooltip
      day={day}
      pickersDayProps={pickersDayProps}
      minDate={minDate}
      maxDate={maxDate}
    />
  );

  return (
    <DatePicker
      disabled={disabled}
      value={value || ''}
      renderInput={(params) => (
        <Stack>
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              style: { padding: '0px 0px', textAlign: 'center' },
              'data-hj-allow': '',
              'data-hj-datepicker': '',
              value: value ? params.inputProps.value : '',
            }}
          />
          {value && (
            <Typography variant="caption" sx={{ opacity: value ? 1 : 0 }}>
              {getTimeDiffText(value)}
            </Typography>
          )}
        </Stack>
      )}
      onChange={onChange}
      closeOnSelect={false}
      minDate={minDate}
      maxDate={maxDate}
      components={{
        ActionBar: DatePickerActionDates,
      }}
      componentsProps={{
        actionBar: {
          onAllActions: onChangeAll,
          closeDatePicker,
          handleChange: onChange,
          debtorAveragePaymentDays,
          disableWeekend: true,
          showButtonSubtitle: false,
          buttons: [
            {
              id: 'button-30-days',
              days: 30,
              label: '30',
            },
            {
              id: 'button-45-days',
              days: 45,
              label: '45',
            },
            {
              id: 'button-60-days',
              days: 60,
              label: '60',
            },
          ],
        },
      }}
      PopperProps={{
        placement: 'bottom',
      }}
      shouldDisableDate={shouldDisableWeekend}
      renderDay={handleRenderDay}
    />
  );
};

FingoGridDatePicker.propTypes = {
  debtorAveragePaymentDays: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.instanceOf(dayjs), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onChangeAll: PropTypes.func,
  minDate: PropTypes.instanceOf(dayjs),
  maxDate: PropTypes.instanceOf(dayjs),
  disabled: PropTypes.bool,
  closeDatePicker: PropTypes.func,
  shouldDisableWeekend: PropTypes.func,
};

FingoGridDatePicker.defaultProps = {
  debtorAveragePaymentDays: null,
  value: '',
  onChangeAll: null,
  minDate: dayjs().subtract(180, 'days'),
  maxDate: dayjs().add(150, 'days'),
  disabled: false,
  closeDatePicker: null,
  shouldDisableWeekend: null,
};

export default FingoGridDatePicker;
